import React from "react";
import { TextField, DatePicker } from "@finpay-development/shared-components";
import Grid from "@mui/material/Grid";
import { MenuItem } from "@mui/material";
import { FormSectionProps } from "../types";
import "../../../../tab-styling.scss"
import {Utils} from '@finpay-development/shared-platform/lib/esm/shared/utils';
import {Moment} from 'moment';

export const ContactInfoSection: React.FC<FormSectionProps> = ({
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    setFieldValue,
}) => {
    return (
        <div className="contact-info">
            <Grid container spacing={2}>
                <Grid item xs>
                    <TextField
                        name="email"
                        label="Email Address"
                        value={values.email}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        placeholder="Enter Email Address"
                        className={`${touched.email && Boolean(errors.email) ? 'error-border' : ""}`}
                        helperText={touched.email && errors.email ? String(errors.email) : undefined}
                        test-id="patient-tab-email"
                    />
                </Grid>
                <Grid
                    item
                    xs="auto"
                    style={{ marginLeft: 'auto', display: 'flex', gap: 16 }}
                >
                    <DatePicker
                        label="Date of Birth"
                        className={`date state-field dob-picker ${touched.dateOfBirth && Boolean(errors.dateOfBirth) ? 'error-border' : 'required-fields'}`}
                        value={values.dateOfBirth}
                        onChange={(date: Moment) => {
                            if(date){
                                setFieldValue('dateOfBirth', date.format('YYYY-MM-DD'))
                            }else{
                                setFieldValue('dateOfBirth', null)
                            }
                        }}
                        data="patient-tab-dob"
                    />
                    <TextField
                        select
                        name="genderCode"
                        label="Gender"
                        value={values.genderCode}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        className={`state-field gender-field ${touched.genderCode && Boolean(errors.genderCode) ? 'error-border' : ""}`}
                        test-id="patient-tab-gender"
                    >
                        <MenuItem value="">&nbsp;</MenuItem>
                        <MenuItem value="M">Male</MenuItem>
                        <MenuItem value="F">Female</MenuItem>
                    </TextField>
                </Grid>
                <Grid item xs={12}>
                    <div className="phone-with-checkboxes">
                        <TextField
                            name="firstPhone"
                            label="Primary Phone"
                            test-id='contact-info-record-primary-phone'
                            value={values.firstPhone}
                            maxLength={12}
                            onChange={(e: React.ChangeEvent<any>) => {
                                handleChange(e);
                                setFieldValue(
                                    "firstPhone",
                                    Utils.formatPhoneNumber(
                                        (e.target as HTMLInputElement).value
                                    )
                                );
                            }}
                            onBlur={handleBlur}
                            placeholder="Enter Phone Number"
                            className={`${touched.firstPhone && Boolean(errors.firstPhone) ? 'error-border' : ""}`}
                            helperText={touched.firstPhone && errors.firstPhone ? String(errors.firstPhone) : undefined}
                        />
                        <div className="prim-checkbox-group">
                            <label className="checkbox-label">
                                <input
                                    type="checkbox"
                                    name="isFirstPhoneMobile"
                                    checked={values.isFirstPhoneMobile}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                />
                                <span>Mobile</span>
                            </label>
                            <label className="checkbox-label">
                                <input
                                    type="checkbox"
                                    name="receiveSMSMessages"
                                    checked={values.receiveSMSMessages}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                />
                                <span>Allow SMS</span>
                            </label>
                            <label className="checkbox-label">
                                <input
                                    type="checkbox"
                                    name="leaveVoicemail"
                                    checked={values.leaveVoicemail}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                />
                                <span> Leave VM</span>
                            </label>
                        </div>
                    </div>

                </Grid>
                <Grid item xs={12}>
                    <div className="phone-with-checkboxes">
                        <TextField
                            name="secondPhone"
                            className={`${touched.secondPhone && Boolean(errors.secondPhone) ? 'error-border' : ""}`}
                            label="Secondary Phone"
                            value={values.secondPhone}
                            maxLength={12}
                            onChange={(e: React.ChangeEvent<any>) => {
                                handleChange(e);
                                setFieldValue(
                                    "secondPhone",
                                    Utils.formatPhoneNumber(
                                        (e.target as HTMLInputElement).value
                                    )
                                );
                            }}
                            onBlur={handleBlur}
                            placeholder="Enter Phone Number"
                            helperText={touched.secondPhone && errors.secondPhone ? String(errors.secondPhone) : undefined}
                        />
                        <label className="checkbox-label">
                            <input
                                type="checkbox"
                                name="isSecondPhoneMobile"
                                checked={values.isSecondPhoneMobile}
                                onChange={handleChange}
                                onBlur={handleBlur}
                            />
                            <span>Mobile</span>
                        </label>
                    </div>

                </Grid>
            </Grid>
        </div >
    );
}; 